module.exports = __webpack_public_path__ + "img/nuevo-mas.e7d4fe55.svg";